const mapLowestMarginMarket = market => {
  if (!market) return null

  return {
    country_code: market.country_code,
    margin_percentage: market.margin_percentage,
  }
}

export const transformResponsePerformanceInsightsNumbers = numbers => {
  return {
    currency: numbers.currency,
    orders_count: numbers.orders_count,
    average_order_value: numbers.average_order_value,
    returned_orders_percentage: numbers.returned_orders_percentage,
    returned_orders_count: numbers.returned_orders_count,
    earnings_retained: numbers.earnings_retained,
    lowest_margin_market: mapLowestMarginMarket(numbers.lowest_margin_market),
    negative_margin_skus_count: numbers.negative_margin_skus_count,
    free_shipping_covered_percentage: numbers.free_shipping_covered_percentage,
    free_shipping_covered_amount: numbers.free_shipping_covered_amount,
  }
}
